import type { DfuUpdate } from "./updates.js";
import type {
  DfuAbstractTransport,
  ProgressCallback,
} from "./abstract-transport.js";

export class DfuOperation {
  constructor(
    private readonly updates: DfuUpdate[],
    private readonly transport: DfuAbstractTransport,
  ) {}

  setProgressCallback(cb: ProgressCallback | undefined): void {
    this.transport.setProgressCallback(cb);
  }

  async start(): Promise<void> {
    for (const u of this.updates) {
      await this.transport.sendInitPacket(u.initPacket);
      await this.transport.sendFirmwareImage(u.firmwareImage);
    }
  }
}
